/* globals firebase */

import { track, ERROR, ENROLL } from '@updater-core/lib/tracker';
import { ENVIRONMENT as env } from '@updater-core/lib/environment';
import { fetchGraphQLQuery } from '../../apps/angularjs/helpers/graphql';
import gql from 'graphql-tag';

const handleError = (ex, source) => {
  if (window.console && window.console.error) {
    console.error(ex); // eslint-disable-line no-console
  }
  track({
    verb: ERROR,
    object: `${source}_fetch_error`,
    details: {
      message: ex.message,
      stack: ex.stack,
      ...ex,
    },
  });
};

const registerBrowserTokenQuery = gql`
  mutation RegisterBrowserToken($input: RegisterBrowserTokenInput!) {
    registerBrowserToken(input: $input) {
      code
      message
      success
    }
  }
`;

const getToken = (messaging, headers, errorMessage) => {
  return messaging.getToken().then((currentToken) => {
    if (currentToken) {
      fetchGraphQLQuery({
        headers,
        query: registerBrowserTokenQuery,
        url: `${env.endpoints.api.url}/graphql`,
        variables: {
          input: {
            browserToken: currentToken,
          },
        },
      }).catch((e) => {
        handleError(e, errorMessage);
      });
    } else {
      console.log(
        'No Instance ID token available. Request permission to generate one.'
      );
    }
  });
};

export const buildWebpushNotification = ({ interactors: { session } }) => {
  const unsubscribe = session.subscribe((state) => {
    const headers = session.selectors.requestHeaders(state);

    if (headers && session.selectors.isAuthenticated(state)) {
      unsubscribe();
      if ('Notification' in window) {
        let messaging;
        try {
          // Your web app's Firebase configuration
          const firebaseConfig = env.keys.firebase || {};
          firebase.initializeApp(firebaseConfig);
          firebase.analytics();

          messaging = firebase.messaging();
        } catch (e) {
          track({
            object: 'firebase_messaging_init',
            verb: ERROR,
            details: {
              message: e.message,
              stack: e.stack,
              ...e,
            },
          });
        }

        if (!messaging) {
          return;
        }

        const vapidKey = env.keys.firebase_cm.vapidKey || '';
        // Add the public key generated from the console here.
        messaging.usePublicVapidKey(vapidKey);

        Notification.requestPermission().then(function (permission) {
          if (permission === 'granted') {
            track({
              domain: 'browser',
              object: 'notifications',
              verb: ENROLL,
              details: {},
            });

            getToken(messaging, headers, 'webpush_browserToken').catch(
              (err) => {
                //if the user had already accepted the token and request a token again, the first try will be unsuccessful so we request a token again.
                getToken(messaging, headers, 'webpush_browserToken_retry');
                console.log('An error occurred while retrieving token. ', err);
              }
            );
          } else {
            console.log('Unable to get permission to notify.');
          }
        });
      }
    }
  });
};
